import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/link_24.svg.ts
import { svg } from "lit";
var link24Svg = svg`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M9 18H7.5C6.71207 18 5.93185 17.8448 5.2039 17.5433C4.47595 17.2418 3.81451 16.7998 3.25736 16.2426C2.13214 15.1174 1.5 13.5913 1.5 12C1.5 10.4087 2.13214 8.88258 3.25736 7.75736C4.38258 6.63214 5.9087 6 7.5 6H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M15 18H16.5C17.2879 18 18.0681 17.8448 18.7961 17.5433C19.5241 17.2418 20.1855 16.7998 20.7426 16.2426C21.8679 15.1174 22.5 13.5913 22.5 12C22.5 10.4087 21.8679 8.88258 20.7426 7.75736C19.6174 6.63214 18.0913 6 16.5 6H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M7.49988 12H16.4999" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export {
  link24Svg
};
//# sourceMappingURL=link_24.svg-ME7P2JZJ.js.map
